var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(113, 102, 240, 0.15)",
              expression: "'rgba(113, 102, 240, 0.15)'",
              modifiers: { "400": true }
            },
            {
              name: "b-modal",
              rawName: "v-b-modal.modal-navigation-user",
              modifiers: { "modal-navigation-user": true }
            }
          ],
          staticClass: "waves-effect",
          attrs: { variant: "outline-warning" }
        },
        [_vm._v(" " + _vm._s(_vm.$t("user_access_data")) + " ")]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-navigation-user",
            "cancel-variant": "outline-secondary",
            "hide-footer": "true",
            scrollable: "",
            size: "xl",
            title: _vm.$t("user_access_data")
          }
        },
        [
          _c("b-table", {
            attrs: {
              hover: "",
              "caption-top": "",
              responsive: "sm",
              "table-variant": "warning",
              items: _vm.listItensUserAccess,
              fields: _vm.fieldsTableUserAccessModal
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }